import * as z from 'zod';

export const mswConfigSchema = z.object({
  enabled: z.stringbool().default(false),
});

export type MswConfig = z.infer<typeof mswConfigSchema>;

export const mswConfig = mswConfigSchema.parse({
  enabled: import.meta.env.APP_CLIENT_WEB_MSW_ENABLED,
});
